<template>
    <div>
        <tab name="9"></tab>
        <div class="page-filter-box">
            <el-row :gutter="20">
				<el-col  :xs="24" :sm="12" :md="14" :lg="11" :xl="8">
				    <el-input v-model="params.searchValue" class="input-with-select" size="small">
				        <el-select v-model="params.searchType" slot="prepend" placeholder="请选择">
				            <el-option label="演出ID" :value="1"></el-option>
				            <el-option label="演出名称" :value="2"></el-option>         
				        </el-select>
				    </el-input>
				</el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="8" :xl="4">
                    <el-select v-model="params.sort" placeholder="请选择" size="small">
                        <el-option label="优先展示最新日期的" :value="0"></el-option>
                        <el-option label="优先展示销售总额最多的" :value="1"></el-option>
                        <el-option label="优先展示订单总数最多的" :value="2"></el-option>
                        <el-option label="优先展示售票总数最多的" :value="3"></el-option>
                        <el-option label="优先展示演出总数最多的" :value="4"></el-option>
                    </el-select>
                </el-col>
                <el-col :xs="24" :sm="12" :md="8" :lg="5" :xl="4" class="page-filter-btns">
                    <el-button type="primary" icon="el-icon-search" @click="search" size="small">查询</el-button>
                    <el-button type="default" icon="el-icon-refresh" @click="reset" size="small">重置</el-button>
                </el-col>
            </el-row>
        </div>
        <div class="page-list-box">
            <el-table
                :data="dataList"
                border
                style="width: 100%"
                v-loading="listLoading"
                size="small"
                stripe
            >
                <el-table-column prop="timeStr" label="日期" :min-width="150"></el-table-column>
                <el-table-column prop="amount" label="销售总额"></el-table-column>
                <el-table-column prop="totalNum" label="售票总数"></el-table-column>
                <el-table-column prop="orderNum" label="订单总数"></el-table-column>
                <el-table-column prop="activityNum" label="演出总数"></el-table-column>
            </el-table>
        </div>
        <div v-if="data" class="page-pagination-box">
            <el-pagination
                background
                @size-change="pageSizeChange"
                @current-change="pageNoChange"
                :current-page.sync="params.pageNo"
                :page-sizes="$pageSizes"
                :page-size.sync="params.pageSize"
                layout="total, sizes, prev, pager, next"
                :total="data.totalCount || 0">
            </el-pagination>
        </div>
    </div>
</template>

<script>
import Tab from './../../components/tab';

export default {
    components:{Tab},
    data(){
        this.defaultParams = {
			searchType:1,
			searchValue: '',
            sort: 0,
            pageNo: 1,
            pageSize: this.$pageSizes[0]
        };

        return{
            data: null,
            dataList: null,
            params: {
				...this.defaultParams,
				searchType:parseInt(this.$route.query.searchType || 1),
				searchValue: this.$route.query.searchValue || '',
				pageNo:parseInt(this.$route.query.pageNo || 1),
				pageSize: parseInt(this.$route.query.pageSize || this.$pageSizes[0]),
			},
            listLoading: false,
            filter: null,
            exportDataLoading: false  
        }
    },
    created() {
        this.getDataList();
    },
    methods:{
        //获取列表
        async getDataList() {
            const {terminal, timeStart, timeEnd} = this.$route.query;
            const {...params} = this.params;

            this.listLoading = true;

            const res = await this.$request({
                url: '/sales/terminal/data_list',
                method: 'post',
                data: {...params, terminal, timeStart, timeEnd}
            }).catch(() => {
                return {data: {state: '0', msg: '请求错误'}};
            }).finally(() => {
                this.listLoading = false;
            });

            const { state, msg, result } = res.data;

            if(state !== '1') {
                return this.$message.error(msg || '请求失败');
            }

            this.data = result;
            this.dataList = result.result || [];

            this.filter = {...params, terminal, timeStart, timeEnd};
        },
         //选择pageSize
        pageSizeChange() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        pageNoChange() {
            this.getDataList();
        },
        //搜索
        search() {
            this.params.pageNo = 1;
            this.getDataList();
        },
        //重置搜索
        reset() {
            this.params = {...this.defaultParams};
            this.getDataList();
        },
    }
}
</script>